import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppService } from 'app/app.service';
import { NavigationService } from 'app/services';

export const systemGuard: CanActivateFn = () => {
    const appService = inject(AppService);
    const navigation = inject(NavigationService);

    try {
        if (['system'].includes(appService.user.owner.type.toLowerCase())) {
            return true;
        }
        return navigation.getDefaultUrlTree();
    } catch (error) {
        console.error(error);
        return navigation.getDefaultUrlTree();
    }
}
